import FirebaseConfig from "../firebaseConfig";

const db = FirebaseConfig.firestore(),
  usersRef = db.collection("admins");

export async function getUser(docId) {
  let uid = localStorage.getItem("token");
  uid = uid ? uid : FirebaseConfig.auth().currentUser.uid;
  localStorage.setItem("token", uid);
  try {
    const user = await usersRef.doc(docId ? docId : uid).get();
    return user.data();
  } catch (error) {
    console.log("error  ", error);
    return false;
  }
}
